var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import createPermissionFeatureWithoutStoreHook from './CreatePermissionFeatureWithoutStoreHook';
export default function createPermissionFeatureHook() {
    return function (permissionEnum, useDataAccessStoreHook) {
        var usePermissionFeatureWithoutStore = createPermissionFeatureWithoutStoreHook()(permissionEnum);
        return function () {
            var permissionFeatureWithoutStore = usePermissionFeatureWithoutStore();
            var dataAccessStore = useDataAccessStoreHook();
            var permissionFeatureHookFunctions = useMemo(function () {
                return __assign(__assign({}, permissionFeatureWithoutStore), { hasOnActiveItemPermission: function (permission) {
                        if (!dataAccessStore.activeItem) {
                            return false;
                        }
                        return permissionFeatureWithoutStore.hasPermission(dataAccessStore.activeItem.id, permission);
                    }, hasOnActiveItemPermissions: function (permissions) {
                        if (!dataAccessStore.activeItem) {
                            return false;
                        }
                        return permissionFeatureWithoutStore.hasPermissions(dataAccessStore.activeItem.id, permissions);
                    } });
            }, [permissionFeatureWithoutStore, dataAccessStore]);
            return permissionFeatureHookFunctions;
        };
    };
}
//# sourceMappingURL=CreatePermissionFeatureHook.js.map